import axios from "axios";
import { baseURL } from "./constants";

const loginApi = async (email, password) => {
  return axios.post(`${baseURL}/auth/local`, { email: email, password });
};

const logoutApi = async (currentUser) => {
  return axios.post(`${baseURL}/auth/logout`, {},
    {
      headers: {
        Authorization: `Bearer ${currentUser?.jwt}`,
      },
    }
  );
};

const forgotPasswordApi = async (email) => {
  return axios.post(`${baseURL}/auth/forgot-password`, { email });
};

const resetPasswordApi = async ({ newPassword, confirmPassword, code }) => {
  return axios.post(`${baseURL}/auth/reset-password`, {
    password: newPassword,
    passwordConfirmation: confirmPassword,
    code,
  });
};

const resetPasswordCodeCheck = async (code) => {
  return axios.get(`${baseURL}/auth/code-link-valid`, {
    params: {
      code: code
    }
  });
};

const sendOtpApi = async (email) => {
  return axios.post(`${baseURL}/auth/send-otp`, { email });
};

const verifyOtpApi = async (email, otp) => {
  return axios.post(`${baseURL}/auth/verify-otp`, { email, otp });
};

const sendLoginLinkApi = async (email) => {
  return axios.post(`${baseURL}/auth/send-magic-link`, { email });
};

const verifyMagicLinkApi = async (token) => {
  return axios.get(`${baseURL}/auth/verify-magic-link`, {
    params: { token },
  });
};


export { loginApi, logoutApi, forgotPasswordApi, resetPasswordApi, resetPasswordCodeCheck, sendOtpApi, verifyOtpApi, sendLoginLinkApi, verifyMagicLinkApi };
